/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For 10 reactions at 10% overage, each reagent is scaled ×11.`)
};

const es_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 10 reacciones con 10% de exceso, cada reactivo se escala ×11.`)
};

const de_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei 10 Reaktionen mit 10 % Überschuss wird jedes Reagenz um den Faktor 11 skaliert.`)
};

const nl_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor 10 reacties met 10% overmaat wordt elk reagens ×11 geschaald.`)
};

const fr_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour 10 réactions avec 10 % de marge, chaque réactif est multiplié ×11.`)
};

const it_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per 10 reazioni con margine del 10%, ogni reagente è scalato ×11.`)
};

const pt_br2_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 10 reações com 10% de excedente, cada reagente é multiplicado por 11.`)
};

const pt_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para 10 reações com 10% de excedente, cada reagente é escalado ×11.`)
};

const ja_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10反応、オーバーヘッジ10%の場合、各試薬は×11にスケーリングされます。`)
};

const zh_pcr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 个反应、损耗余量 10% 时，每种试剂放大 ×11。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_ex1", locale)
	if (locale === "en") return en_pcr_ex1(inputs)
	if (locale === "es") return es_pcr_ex1(inputs)
	if (locale === "de") return de_pcr_ex1(inputs)
	if (locale === "nl") return nl_pcr_ex1(inputs)
	if (locale === "fr") return fr_pcr_ex1(inputs)
	if (locale === "it") return it_pcr_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_ex1(inputs)
	if (locale === "pt") return pt_pcr_ex1(inputs)
	if (locale === "ja") return ja_pcr_ex1(inputs)
	return zh_pcr_ex1(inputs)
};